import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Body1, Body2, Button, Tooltip, Link } from '@fluentui/react-components';
import { Status, StatusIcon } from '@bingads-webui-campaign-react/status-popover';

import { useStyles } from '../../styles/action-cards-styles';

export function ActionCard({
  name,
  status,
  cardTitle,
  cardMsg,
  onCardButtonClicked,
  cardButtonText,
  learnMoreLink,
  i18n,
}) {
  const classes = useStyles();

  return (
    <div className={classNames('ba-diagnostic-action-card', classes.card)}>
      <div className={classNames('ba-diagnostic-action-card-icon', classes.iconArea)}>
        <StatusIcon status={status} />
        <Body2 className={classNames(classes.nameText)}>{name}</Body2>
      </div>
      <Tooltip content={cardTitle} relationship="label">
        <Body1 block className={classNames('ba-diagnostic-action-card-title', classes.cardTitle)}>{cardTitle}</Body1>
      </Tooltip>
      <Tooltip content={cardMsg} relationship="label">
        <Body1 block className={classNames('ba-diagnostic-action-card-message', classes.cardMessage)}>{cardMsg}</Body1>
      </Tooltip>
      <span className={classes.footer}>
        { onCardButtonClicked && cardButtonText &&
          <Button
            onClick={onCardButtonClicked}
            className={classNames('ba-diagnostic-action-card-button', classes.cardButton)}
          >
            {cardButtonText}
          </Button>
        }
        {learnMoreLink &&
          <Link href={learnMoreLink} target="_blank" rel="noopener noreferrer" className="learn-more">{i18n.getString(_TL_('Learn more'))}</Link>
        }
      </span>
    </div>
  );
}

ActionCard.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.oneOf(Object.values(Status)).isRequired,
  cardTitle: PropTypes.string.isRequired,
  cardMsg: PropTypes.string.isRequired,
  onCardButtonClicked: PropTypes.func,
  cardButtonText: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  learnMoreLink: PropTypes.string,
};

ActionCard.defaultProps = {
  learnMoreLink: undefined,
  onCardButtonClicked: undefined,
  cardButtonText: undefined,
};
